// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hV8O","toggleWrap":"styles_toggleWrap__1QfRA","content":"styles_content__3-m76","selectAreaCode":"styles_selectAreaCode__2baBs"};